// extracted by mini-css-extract-plugin
export default {"iconoFlecha":"Contact_iconoFlecha__NznYJ","button":"Contact_button__Z0DRZ"};